import { render, staticRenderFns } from "./AlertNew.vue?vue&type=template&id=fbb7f4c6"
import script from "./AlertNew.vue?vue&type=script&lang=js"
export * from "./AlertNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports